module.exports = __webpack_public_path__ + "img/139824.e57f577c.png";